import { Divider, Stack, SxProps, Typography } from '@mui/material';
import { shortDateFormat } from 'Config';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { format } from 'date-fns';
import { ITreatmentStage, TreatmentStage } from './TreatmentStage';

interface IGeneralData {
  matter: string;
  treatmentStage: ITreatmentStage;
  updateDate: Date | undefined;
  isSingleClaimEventView?: boolean;
  nextStep?: string | undefined;
}
export const GeneralData = ({
  matter,
  treatmentStage,
  updateDate,
  isSingleClaimEventView,
  nextStep,
}: IGeneralData) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Status).generalData;
  const isDesktop = useIsDesktop();

  const stackTextStyle: SxProps = {
    rowGap: isDesktop ? '8px' : '4px',
    width: 'fit-content',
  };

  const isSingleClaimEventViewMobile = isSingleClaimEventView && !isDesktop;

  return (
    <Stack
      direction={isDesktop ? 'row' : 'column'}
      justifyContent={isSingleClaimEventView ? undefined : 'space-between'}
      mb={isDesktop ? undefined : '32px'}
      columnGap={isSingleClaimEventView ? '64px' : undefined}
    >
      <Stack
        sx={{
          ...stackTextStyle,
          mb: isSingleClaimEventViewMobile ? '20px' : undefined,
        }}
        maxWidth={
          isDesktop ? (isSingleClaimEventView ? undefined : '220px') : undefined
        }
        minWidth={isSingleClaimEventView ? '200px' : undefined}
      >
        <Typography variant='body6'>{dictionary.matter}</Typography>
        <Typography variant='body1' component='h5'>
          {matter}
        </Typography>
      </Stack>
      {!isDesktop &&
        (isSingleClaimEventView ? null : (
          <Divider
            sx={{ margin: '12px 0 20px 0', borderColor: 'primary.shade_100' }}
          />
        ))}
      <Stack
        direction='row'
        width={isDesktop ? '340px' : undefined}
        columnGap={
          isDesktop ? (isSingleClaimEventView ? '48px' : '64px') : '24px'
        }
        rowGap={isSingleClaimEventViewMobile ? '20px' : undefined}
        justifyContent='space-between'
        flexWrap={isSingleClaimEventViewMobile ? 'wrap' : 'nowrap'}
      >
        <Stack sx={{ ...stackTextStyle }}>
          <Typography
            variant='body6'
            sx={{
              minWidth: isSingleClaimEventView
                ? isDesktop
                  ? '200px'
                  : 'fit-content'
                : undefined,
            }}
          >
            {dictionary.treatmentStage}
          </Typography>
          <TreatmentStage data={treatmentStage} />
        </Stack>
        <Stack sx={{ ...stackTextStyle }}>
          <Typography variant='body6' whiteSpace='nowrap'>
            {dictionary.lastUpdate}
          </Typography>
          <Typography variant='body2'>
            {updateDate ? format(new Date(updateDate), shortDateFormat) : ''}
          </Typography>
        </Stack>
        {isSingleClaimEventView && nextStep && (
          <Stack sx={{ ...stackTextStyle }}>
            <Typography variant='body6' whiteSpace='nowrap'>
              {dictionary.nextStep}
            </Typography>
            <Typography variant='body2' sx={{ whiteSpace: 'nowrap' }}>
              {nextStep}
            </Typography>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
